"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScheduledEmailSummaryString = void 0;
var constants_1 = require("../constants");
var datetime_1 = require("./datetime");
var AM = "AM";
var PM = "PM";
function getRepeatFrequecyType(repeatFrequency) {
    // eslint-disable-next-line no-prototype-builtins
    return constants_1.FREQUENCY_TYPE.find(function (type) { return repeatFrequency.hasOwnProperty(type); });
}
function getScheduledEmailRepeatString(intl, options) {
    var _a = options.repeatData, repeatType = _a.repeatType, repeatPeriod = _a.repeatPeriod, repeatFrequency = _a.repeatFrequency, repeatExecuteOn = _a.repeatExecuteOn, startDate = options.startDate;
    var isCustomRepeatType = repeatType === constants_1.REPEAT_TYPES.CUSTOM;
    var day = datetime_1.getDayName(startDate);
    var week = datetime_1.getWeek(startDate);
    if (!isCustomRepeatType) {
        return intl.formatMessage({ id: "dialogs.schedule.email.repeats.types." + repeatType }, { day: day, week: week });
    }
    var every = intl.formatMessage({
        id: "dialogs.schedule.email.repeats.every",
    });
    var repeatFrequecyType = getRepeatFrequecyType(repeatFrequency);
    var frequencies = intl.formatMessage({
        id: "dialogs.schedule.email.repeats.frequencies." + repeatFrequecyType,
    }, {
        n: repeatPeriod,
    });
    var appliedRepeatExecuteOn = repeatFrequecyType === constants_1.REPEAT_FREQUENCIES.WEEK ? constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK : repeatExecuteOn;
    var executeOn = repeatFrequecyType !== constants_1.REPEAT_FREQUENCIES.DAY
        ? intl.formatMessage({
            id: "dialogs.schedule.email.repeats.execute.on." + appliedRepeatExecuteOn,
        }, {
            date: datetime_1.getDate(startDate),
            day: datetime_1.getDayName(startDate),
            week: datetime_1.getWeek(startDate),
        })
        : "";
    // every 2 months on the first Friday
    return (every + " " + repeatPeriod + " " + frequencies + " " + executeOn).trim();
}
function getFormattedTime(time) {
    var hour = time.hour, minute = time.minute;
    var timeSuffix = getTimePeriod(hour);
    var formattedMinute = getFormattedMinute(minute);
    var formatedHour = getFormattedHour(hour);
    // 12:00 AM
    return formatedHour + ":" + formattedMinute + " " + timeSuffix;
}
function getTimePeriod(hour) {
    return hour >= 12 ? PM : AM;
}
function getFormattedMinute(minute) {
    return minute < 10 ? "0" + minute : "" + minute;
}
function getFormattedHour(hour) {
    var fortmattedHour = hour > 12 ? hour - 12 : hour;
    if (hour === 0) {
        fortmattedHour = 12;
    }
    return fortmattedHour;
}
function getScheduledEmailSummaryString(intl, options) {
    var repeatDays = getScheduledEmailRepeatString(intl, options);
    var atLocalization = intl.formatMessage({ id: "gs.date.at" });
    var time = getFormattedTime(options.repeatData.time);
    // every 2 months on the first Friday at 12:00 AM
    return repeatDays + " " + atLocalization + " " + time;
}
exports.getScheduledEmailSummaryString = getScheduledEmailSummaryString;
//# sourceMappingURL=scheduledMailSummary.js.map